import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url() {
    return buildApiUrl(ADMIN_ENDPOINTS.KYC_LIST, {
      queryParams: {
        type: 'restaurant',
        limit: 100
      }
    })
  },

  parse(raw = {}) {
    // MonRapidoo API retourne statusCode/message au lieu de success
    if (!raw?.statusCode || raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to fetch KYC data',
        data: null,
      }
    }

    const kycDocuments = raw.data?.data || [] // Tableau dans data.data

    const formatted = kycDocuments.map(el => {
      const kycData = el.data || {}
      const metadata = el.metadata || {}
      const verification = el.verification || {}

      return {
        id: el.id,
        userId: el.userId,
        userType: el.userType || 'restaurant',
        status: el.status || 'draft',
        uploadedAt: el.submittedAt || el.createdAt,
        createdAt: el.createdAt,
        updatedAt: el.updatedAt,

        // Restaurant-specific fields mapping
        userName: kycData.personalInfo?.firstName && kycData.personalInfo?.lastName
          ? `${kycData.personalInfo.firstName} ${kycData.personalInfo.lastName}`.trim()
          : kycData.storeName || kycData.personalInfo?.companyName || 'Restaurant',
        storeName: kycData.storeName || kycData.personalInfo?.companyName || '',
        companyName: kycData.personalInfo?.companyName || '',
        firstName: kycData.personalInfo?.firstName || '',
        lastName: kycData.personalInfo?.lastName || '',
        fullName: kycData.personalInfo?.firstName && kycData.personalInfo?.lastName
          ? `${kycData.personalInfo.firstName} ${kycData.personalInfo.lastName}`.trim()
          : '',
        userEmail: kycData.personalInfo?.email || kycData.userEmail || kycData.email || '-',
        phoneNumber: kycData.personalInfo?.phone || kycData.phoneNumber || '-',
        website: kycData.personalInfo?.website || kycData.website || '',
        addresss: kycData.personalInfo?.address || kycData.address || kycData.addresss || '-',
        city: kycData.personalInfo?.city || '-',
        countryCode: kycData.personalInfo?.countryCode || kycData.personalInfo?.country || '-',
        postalCode: kycData.personalInfo?.postalCode || '',
        state: kycData.personalInfo?.state || '',

        // Restaurant photos
        pictures: kycData.pictures || [],

        // ID document
        idType: kycData.identityDocument?.type,
        idNumber: kycData.identityDocument?.number,
        idExpiryDate: kycData.identityDocument?.expirationDate,
        idFrontUrl: kycData.identityDocument?.frontPhotoUrl,
        idBackUrl: kycData.identityDocument?.backPhotoUrl,

        // Vehicle document
        vehicleType: kycData.vehicleDocument?.type,
        licenseNumber: kycData.vehicleDocument?.number,
        vehiclePhotoUrl: kycData.vehicleDocument?.photoUrl,
        vinNumber: kycData.vehicleDocument?.vinNumber,

        // Selfie
        selfieUrl: kycData.selfieUrl || '',

        // Metadata and verification
        requiredSteps: metadata.requiredSteps || [],
        completedSteps: metadata.completedSteps || [],
        nextAction: metadata.nextAction || '',
        rejectionReason: verification.reason || '',
        rejectionNotes: verification.notes || '',
        reviewBy: verification.reviewedBy || '',
        reviewedAt: verification.reviewedAt || '',

        // Raw KYC data for details view
        kycData: kycData,
      }
    })

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: formatted.length,
        result: formatted,
      },
    }
  },
}
